import React from 'react'
import styled from 'styled-components'

import { getSrcSetStr } from 'helpers/image'
import { Modal, Fonts, Button } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

interface ModalCreditCardRejectedProps {
  isOpen: boolean
  error: string
  onRequestClose: () => void
  onClickChangePayment: () => void
}

const creditCardRejectedImg = `${process.env.PUBLIC_URL}/assets/payment/icon-credit-card-rejected.png`
const warningImg = `${process.env.PUBLIC_URL}/assets/generic/modal/warning.png`

const ModalCreditCardRejected = ({
  isOpen,
  error,
  onRequestClose,
  onClickChangePayment,
}: ModalCreditCardRejectedProps) => {
  const { t } = useTranslation()

  const isErrorCardExpired = error === 'expiration date cannot be in the past'

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} zindex="9999" hideCloseButton={false}>
      {isErrorCardExpired ? (
        <ModalContainer>
          <img
            alt="generic-warning-icon"
            src={warningImg}
            srcSet={getSrcSetStr({ img: warningImg, hires2x: true, hires3x: true })}
          />
          <ModalTitleGeneric>{t('modalCreditCardExpiredTitle')}</ModalTitleGeneric>
          <ModalText>{t('modalCreditCardExpiredDes')}</ModalText>
          <Button minWidth="200px" onClick={onClickChangePayment}>
            {t('btnOK')}
          </Button>
        </ModalContainer>
      ) : (
        <ModalContainer>
          <img
            alt="generic-warning-icon"
            src={creditCardRejectedImg}
            srcSet={getSrcSetStr({ img: creditCardRejectedImg, hires2x: true, hires3x: true })}
          />
          <ModalTitleGeneric>{t('modalCreditCardRejectedTitle')}</ModalTitleGeneric>
          <ModalText>{error}</ModalText>
          <Button minWidth="200px" onClick={onClickChangePayment}>
            {t('dineInButtonChangePaymentType')}
          </Button>
        </ModalContainer>
      )}
    </Modal>
  )
}

export default ModalCreditCardRejected

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 5px;
`

const ModalTitleGeneric = styled(Fonts.H2)`
  margin-top: 20px;
  text-align: center;
  color: black;
`

const ModalText = styled.div`
  font-weight: ${Fonts.weight.normal};
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 16px;
  white-space: pre-wrap;
`
